import axios from "axios";
import Cookies from "js-cookie";

// Create a variable to store the showBlocked function
let showBlockedFn: (() => void) | null = null;

// Function to set the showBlocked function from the context
export const setShowBlocked = (fn: () => void) => {
  showBlockedFn = fn;
};

export const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const mobileClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_MOBILE_PUBLIC_BE_URL,
  // baseURL: "put your url here",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    let res = error.response;
    if (res?.status == 401) {
      if (showBlockedFn) {
        showBlockedFn();
      }
    }
    console.error(
      "Looks like there was a problem. Status Code: " + res?.status
    );
    return Promise.reject(error);
  }
);

mobileClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    let res = error.response;
    if (res?.status == 401) {
      if (showBlockedFn) {
        showBlockedFn();
      }
    }
    console.error(
      "Looks like there was a problem. Status Code: " + res?.status
    );
    return Promise.reject(error);
  }
);

export const authPostRequest = async (
  url: string,
  data?: any,
  //  p0?: { headers: { "Content-Type": string; };},
  isFileUpload: boolean = false
) => {
  try {
    const token = Cookies.get("token");
    const config: any = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    if (isFileUpload) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    const response = await apiClient.post(url, data || {}, config);
  
    return response;
  } catch (error) {
    console.error("Auth POST request failed:", error);
    throw error;
  }
};


export const authfileUploadforChatbot = async (
  url: string,
  data?: any,
) => {
  try {
    const token = Cookies.get("token");
    const config: any = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
    };
    const response = await apiClient.post(url, data || {}, config);
    return response;
  } catch (error) {
    console.error("Auth POST request failed:", error);
    throw error;
  }
};
export const authPutRequest = async (
  url: string,
  data: any,
  isFileUpload: boolean = false,
  isPublicRequest: boolean = false
) => {
  try {
    const token = Cookies.get("token");
    const config: any = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    if (isFileUpload) {
      config.header["Content-type"] = "multipart/form-data";
    }
    const response = (await isPublicRequest)
      ? apiClient.put(url, data)
      : apiClient.put(url, data, config);
    return response;
  } catch (e) {
    console.error("Auth PUT request failed:", e);
    throw e;
  }
};

export const authGetRequest = async (url: string) => {
  try {
    const token = Cookies.get("token");

    const config: any = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await apiClient.get(url, config);

    return response;
  } catch (error) {
    console.error("Auth GET request failed:", error);
    throw error;
  }
};

export const authMobileGetRequest = async (url: string) => {
  try {
    const token = Cookies.get("token");

    const config: any = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await mobileClient.get(url, config);

    return response;
  } catch (error) {
    console.error("Auth GET request failed:", error);
    throw error;
  }
};

export const authPatchRequest = async (url: string, data: any) => {
  try {
    const token = Cookies.get("token");

    const config: any = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await apiClient.patch(url, data, config);

    return response;
  } catch (error) {
    console.error("Auth PATCH request failed:", error);
    throw error;
  }
};

export const authDeleteRequest = async (url: string, data?: any) => {
  try {
    const token = Cookies.get("token");

    const config: any = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    };

    const response = await apiClient.delete(url, config);
    return response;
  } catch (error) {
    console.error("Auth DELETE request failed:", error);
    throw error;
  }
};
// for file-handling
export const authPostFileRequest = async (url: string, data: any) => {
  try {
    const token = Cookies.get("token");
    const config: any = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
    };
    const response = await apiClient.post(url, data, config);
    return response;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorData = error.response.data;
      const errorBlob = new Blob([errorData], { type: "text/plain" });
      const errorText = await errorBlob.text();
      console.error("Auth POST request failed:", errorText);
      throw error;
    } else {
      console.error("Auth POST request failed:", error.message);
    }
  }
};
